<template>
  <div class="paymentWrapper goldenbg">
    <div
      v-show="$store.state.appConfig.showLoader"
      class="axios-loader"
    >
      <loader />
    </div>
    <div class="pmBackBtn">
      <b-button
        class="pm-back-btn-ft"
        @click="$router.go(-1)"
      />
    </div>
    <b-row>
      <b-col cols="12">
        <div class="pmLogo floatCss">
          <img :src="pmLogoImg">
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="pmtopBlock floatCss">
          <p>This payment link will expire on <span>{{ dateFormatWithFormatParam(tokenDetail.expiresAt, 'DD MMM YYYY, hh:mma') }}</span>.</p>
          <h2>Review payment</h2>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="showPayment">
      <b-col cols="12">
        <div class="paymentWhiteBlock floatCss">
          <div class="pmblocktittle floatCss">
            <h3>Summary</h3>
          </div>
          <div class="pmSummaryBlock floatCss">
            <div
              v-for="item in items"
              :key="item._id"
              class="pmSummarysinglewrp floatCss"
            >
              <div class="pmSummarysingle floatCss">
                <div class="pmsleft floatCss">
                  <h3>{{ paymentTypeLabel(item) }}</h3>
                  <h3>({{ productLabel(item) }})</h3>
                </div>
                <div class="pmsright floatCss">
                  <p>${{ numberFormat(item.amountDue) }}</p>
                </div>
                <div
                  v-if="item.paymentType === 'downpayment'"
                  class="cls-btn floatCss"
                >
                  <b-button
                    v-b-toggle="'collapse-' + item._id"
                    variant="primary"
                  />
                </div>
              </div>
              <div
                v-if="item.paymentType === 'downpayment'"
                class="payableBlockpm floatCss"
              >
                <b-collapse
                  :id="'collapse-' + item._id"
                  class="cm-gap-1 floatCss"
                >
                  <div class="payableWrapper floatCss">
                    <div class="payableRow floatCss">
                      <span>Downpayment - {{ item.downPaymentPercentage }}%</span>
                      <span>${{ numberFormat(item.downPayment - item.gstAmount) }}</span>
                    </div>
                    <div class="payableRow floatCss">
                      <span>GST {{ item.gstPercentage }}%</span>
                      <span>${{ numberFormat(item.gstAmount) }}</span>
                    </div>
                    <div class="payableRow totalpmRow floatCss">
                      <span>Payable today</span>
                      <span>${{ numberFormat(item.amountDue) }}</span>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <div class="pmSummarysinglewrp tpRowBottom floatCss">
              <div class="pmSummarysingle floatCss">
                <div class="pmsleft floatCss">
                  <h4>Total</h4>
                </div>
                <div class="pmsright floatCss">
                  <p><strong>${{ numberFormat(totalPayable) }}</strong></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="showPayment">
      <b-col cols="12">
        <div class="paymentMethodcontainer floatCss">
          <div class="pmcheckTittle floatCss">
            Select your preferred payment mode
          </div>
          <div class="paymentMethodOptions floatCss">
            <b-form-group>
              <b-form-radio
                v-model="selectedMode"
                name="payment-mode"
                value="card"
              >
                <span class="pmImagefd"><img :src="pmethod1Img"></span>
                <span>Credit Card</span>
              </b-form-radio>
              <b-form-radio
                v-model="selectedMode"
                name="payment-mode"
                value="grabpay"
              >
                <span class="pmImagefd"><img :src="pmethod2Img"></span>
                <span>GrabPay</span>
              </b-form-radio>
            </b-form-group>
          </div>
        </div>
      </b-col>
    </b-row>
    <div
      v-if="showPayment"
      class="bottomFixd floatCss"
    >
      <div class="startBtnpm floatCss">
        <b-button
          class="sts-pm-btn"
          :disabled="!selectedMode || submitting"
          @click="submitPayment"
        >
          Pay {{ items.length }} item{{ items.length === 1 ? '' : 's' }} (${{ numberFormat(totalPayable) }})
        </b-button>
      </div>
      <div class="btmSpInfo floatCss">
        <p>By proceeding with payment, you agree to Nirvana SG’s <a href="#">Privacy Policy</a> and <a href="#">Refund Policy</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BCollapse, BButton, VBToggle, BFormGroup, BFormRadio,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Loader from '../Loader.vue'

export default {
  components: {
    BRow,
    BCol,
    BCollapse,
    BButton,
    BFormGroup,
    BFormRadio,

    Loader,
  },
  directives: {
    'b-toggle': VBToggle,
  },

  data() {
    return {
      // eslint-disable-next-line global-require
      pmLogoImg: require('@/assets/images/mobile/pmLogo.png'),
      // eslint-disable-next-line global-require
      pmethod1Img: require('@/assets/images/mobile/pmethod-1.png'),
      // eslint-disable-next-line global-require
      pmethod2Img: require('@/assets/images/mobile/pmethod-2.png'),
      showPayment: false,
      submitting: false,
      selectedMode: null,
      submissionDetail: {},
      tokenDetail: {},
      items: [],
      totalPayable: 0,
    }
  },

  beforeMount() {
    this.fetchPaymentDetail()
  },

  methods: {
    fetchPaymentDetail() {
      const { token } = this.$route.params
      this.$http.get('front-end/payment/validate/token', { params: { token } })
        .then(response => {
          if (response.data.success && response.data.type === 'sales' && response.data.validToken && !response.data.alreadyPaid) {
            this.showPayment = true
            this.submissionDetail = response.data.submission || {}
            this.tokenDetail = response.data.token || {}
            this.items = response.data.items || []
            this.totalPayable = response.data.totalPayable || 0
          } else {
            this.$router.replace({ name: 'file-payment-frontend-landing', params: { token } })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: (error.data && error.data.message) || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    paymentTypeLabel(item) {
      if (item.paymentType === 'bookingfee') return 'Booking fee'
      if (item.paymentType === 'downpayment') return `Downpayment (${item.downPaymentPercentage}%)`
      return 'Full payment'
    },
    productLabel(item) {
      const location = item.lotNo ? `${item.zoneNo}-${item.lotNo}` : item.packageName
      return `${item.productType}${location ? ` ${location}` : ''}`
    },
    submitPayment() {
      if (!this.selectedMode || this.submitting) return
      if (this.selectedMode === 'card') {
        this.$router.push({ name: 'sales-payment-frontend-card', params: { token: this.$route.params.token } })
        return
      }

      this.submitting = true
      const formData = new FormData()
      formData.append('token', this.$route.params.token)
      formData.append('url', window.location.origin)
      formData.append('paymentMode', 'grabpay')
      formData.append('submissionID', this.submissionDetail._id)

      this.$http.post('front-end/payment/frontend/initiate', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success && response.data.redirectUrl) {
            window.open(response.data.redirectUrl, '_self')
          } else {
            this.submitting = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.submitting = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: (error.data && error.data.message) || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>
